var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable */
import { PluginContainerData, Link } from './common';
import { ButtonData_Type } from './plugin_button.enums';
export function buttonData_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'LINK':
            return ButtonData_Type.LINK;
        case 1:
        case 'ACTION':
            return ButtonData_Type.ACTION;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ButtonData_Type.UNRECOGNIZED;
    }
}
export function buttonData_TypeToJSON(object) {
    switch (object) {
        case ButtonData_Type.LINK:
            return 'LINK';
        case ButtonData_Type.ACTION:
            return 'ACTION';
        default:
            return 'UNKNOWN';
    }
}
var baseButtonData = { type: ButtonData_Type.LINK };
export var ButtonData = {
    fromJSON: function (object) {
        var message = __assign({}, baseButtonData);
        if (object.containerData !== undefined && object.containerData !== null) {
            message.containerData = PluginContainerData.fromJSON(object.containerData);
        }
        else {
            message.containerData = undefined;
        }
        if (object.type !== undefined && object.type !== null) {
            message.type = buttonData_TypeFromJSON(object.type);
        }
        else {
            message.type = ButtonData_Type.LINK;
        }
        if (object.styles !== undefined && object.styles !== null) {
            message.styles = ButtonData_Styles.fromJSON(object.styles);
        }
        else {
            message.styles = undefined;
        }
        if (object.text !== undefined && object.text !== null) {
            message.text = String(object.text);
        }
        else {
            message.text = undefined;
        }
        if (object.link !== undefined && object.link !== null) {
            message.link = Link.fromJSON(object.link);
        }
        else {
            message.link = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.type !== undefined && (obj.type = buttonData_TypeToJSON(message.type));
        message.styles !== undefined &&
            (obj.styles = message.styles ? ButtonData_Styles.toJSON(message.styles) : undefined);
        message.text !== undefined && (obj.text = message.text);
        message.link !== undefined && (obj.link = message.link ? Link.toJSON(message.link) : undefined);
        return obj;
    },
};
var baseButtonData_Styles = {};
export var ButtonData_Styles = {
    fromJSON: function (object) {
        var message = __assign({}, baseButtonData_Styles);
        if (object.border !== undefined && object.border !== null) {
            message.border = ButtonData_Styles_Border.fromJSON(object.border);
        }
        else {
            message.border = undefined;
        }
        if (object.colors !== undefined && object.colors !== null) {
            message.colors = ButtonData_Styles_Colors.fromJSON(object.colors);
        }
        else {
            message.colors = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.border !== undefined &&
            (obj.border = message.border ? ButtonData_Styles_Border.toJSON(message.border) : undefined);
        message.colors !== undefined &&
            (obj.colors = message.colors ? ButtonData_Styles_Colors.toJSON(message.colors) : undefined);
        return obj;
    },
};
var baseButtonData_Styles_Colors = {};
export var ButtonData_Styles_Colors = {
    fromJSON: function (object) {
        var message = __assign({}, baseButtonData_Styles_Colors);
        if (object.text !== undefined && object.text !== null) {
            message.text = String(object.text);
        }
        else {
            message.text = undefined;
        }
        if (object.border !== undefined && object.border !== null) {
            message.border = String(object.border);
        }
        else {
            message.border = undefined;
        }
        if (object.background !== undefined && object.background !== null) {
            message.background = String(object.background);
        }
        else {
            message.background = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.text !== undefined && (obj.text = message.text);
        message.border !== undefined && (obj.border = message.border);
        message.background !== undefined && (obj.background = message.background);
        return obj;
    },
};
var baseButtonData_Styles_Border = {};
export var ButtonData_Styles_Border = {
    fromJSON: function (object) {
        var message = __assign({}, baseButtonData_Styles_Border);
        if (object.width !== undefined && object.width !== null) {
            message.width = Number(object.width);
        }
        else {
            message.width = undefined;
        }
        if (object.radius !== undefined && object.radius !== null) {
            message.radius = Number(object.radius);
        }
        else {
            message.radius = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.width !== undefined && (obj.width = message.width);
        message.radius !== undefined && (obj.radius = message.radius);
        return obj;
    },
};
//# sourceMappingURL=plugin_button.js.map